import { useRef, useState } from "react";
import { InvitationPreview, Label, TemplateCard } from "../components";
import { useContext } from "react";
import { AlertContext } from "../context/AlertContext";
import { domain } from "../consts";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Stepper from "../components/Stepper";
import InvitationFinish from "../components/InvitationFinish";
import TemplateSection from "../components/TemplateSection";
const CreateInvitationPage = () => {
  const { handleAlert } = useContext(AlertContext);
  const [loading, setIsLoading] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  // const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const optionsRef = useRef(null);
  const buttonRef = useRef(null);
  let navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isDropdownOpen &&
        optionsRef.current &&
        !optionsRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);
  const [formData, setFormData] = useState({
    template: 0,
    eventName: "Klara i Ivan",
    date: new Date(),
    location: "",
    headerImage: "",
    includeHeaderImage: true,
    texture: "",
    timelineWithQuote: true,
    quote: true,
    quoteText: "Veselimo se vašem dolasku!",
    quoteAuthor: "",
    events: [
      {
        id: 1,
        eventName: "Ceremonija vjenčanja",
        time: "14:00",
        location: "Katedrala svetog Duje, Peristil",
        icon: "098",
        coordinates: { lat: 43.5080375, lng: 16.440445057010585 },
      },
      {
        id: 2,
        eventName: "Svečani ručak",
        time: "15:30",
        location: "Restoran Gusar",
        icon: "124",
        coordinates: { lat: 43.5157232, lng: 16.4254321 },
      },
      {
        id: 3,
        eventName: "Zabava i ples",
        time: "20:00",
        location: "Stari mornar, Poljudsko šetalište, 21105 Split, Hrvatska",
        icon: "125",
        coordinates: { lat: 43.5201488, lng: 16.4282388 },
      },
    ],
    countdown: true,
    countdownImage: "",
    includeCountdownImage: true,
    countdownFont: "display",
    countdownColor: "#FFFFFF",
    countdownFontSize: 24,
    countdownIsBold: false,
    countdownIsItalic: false,
    formAccommodation: false,
    formExpiryDate: new Date(),
    bgColor: "#F0F4F3",
    fgColor: "D2C6C6",
    opacity: "0.5",
    pattern: "wiggle",
    patternScale: "1",
    textColor: "#FFFFFF",
    highlightColor: "#D4AF37",
    textFont: "display",
    highlightFont: "display",
    border: false,
    borderColor: "#D4AF37",
    borderWidth: 1,
    slug: "",
    includeForm: true,
    includeEmail: true,
    includePhone: true,
    tier: 0,
    titleFont: "display",
    titleColor: "#FFFFFF",
    titleFontSize: 24,
    titleIsBold: false,
    titleIsItalic: false,
    subtitleFont: "display",
    subtitleColor: "#000000",
    subtitleFontSize: 20,
    subtitleIsBold: false,
    subtitleIsItalic: false,
    dateFont: "display",
    dateColor: "#FFFFFF",
    dateFontSize: 18,
    dateIsBold: false,
    dateIsItalic: false,
    locationFont: "display",
    locationColor: "#000000",
    locationFontSize: 16,
    locationIsBold: false,
    locationIsItalic: false,
    quoteFont: "display",
    quoteColor: "#000000",
    quoteFontSize: 18,
    quoteIsBold: false,
    quoteIsItalic: false,
    eventTitleFont: "display",
    eventTitleColor: "#000000",
    eventTitleFontSize: 18,
    eventTitleIsBold: false,
    eventTitleIsItalic: false,
    eventTimeFont: "display",
    eventTimeColor: "#000000",
    eventTimeFontSize: 16,
    eventTimeIsBold: false,
    eventTimeIsItalic: false,
    eventLocationFont: "display",
    eventLocationColor: "#000000",
    eventLocationFontSize: 16,
    eventLocationIsBold: false,
    eventLocationIsItalic: false,
    formTitleText: "Potvrdite svoj dolazak!",
    formTitleFont: "display",
    formTitleColor: "#1F2937",
    formTitleFontSize: 36,
    formTitleIsBold: false,
    formTitleIsItalic: false,
    formSubtitleText: `do ${new Date().toLocaleDateString("hr-HR", {
      day: "numeric",
      month: "long",
      year: "2-digit",
    })}`,
    formSubtitleFont: "display",
    formSubtitleColor: "#374151",
    formSubtitleFontSize: 20,
    formSubtitleIsBold: false,
    formSubtitleIsItalic: false,
    formSuccessText: "Hvala na potvrdi!",
    formSuccessFont: "display",
    formSuccessColor: "#D4AF37",
    formSuccessFontSize: 36,
    formSuccessIsBold: false,
    formSuccessIsItalic: false,
    formButtonFont: "display",
    formButtonColor: "#D4AF37",
    formButtonFontSize: 24,
    formAddGuestText: "+ ima nas još",
    formAddGuestFont: "display",
    formAddGuestColor: "#D4AF37",
    formAddGuestFontSize: 18,
    formAddGuestIsBold: false,
    formAddGuestIsItalic: false,
    includeMessageToGuests: true,
    includeMap: false,
    mapStyle: "default",
    messageToGuestsText: "Vasa napomena gostima",
    messageToGuestsFont: "display",
    messageToGuestsFontSize: 20,
    messageToGuestsColor: "#000000",
    messageToGuestsIsBold: false,
    messageToGuestsIsItalic: false,
    includeEmblem: true,
    emblemLeftLetter: "K",
    emblemRightLetter: "I",
    emblemFont: "display",
    emblemFontSize: 48,
    emblemColor: "#000000",
    emblemLineColor: "#D4AF37",
    emblemIsBold: false,
    emblemIsItalic: false,
    shareTitle: "",
    shareDescription: "",
  });

  const handleSubmit = async (e) => {
    // e.preventDefault();
    if (!formData.slug.length) {
      handleAlert("URL pozivnice ne smije biti prazan");
      return;
    }
    setIsLoading(true);

    // const isFormValid = Object.keys(formErrors).every(
    //   (key) => formErrors[key] === false,
    // );
    //
    // if (!isFormValid || !formData.eventName.length || !formData.slug.length) {
    //   handleAlert("Ispunite sva obvezna polja", "warning");
    //   setIsLoading(false);
    //   return;
    // }

    const url = `${domain}/rsvp${formData.id ? "/" + formData.id : ""}`;

    try {
      const response = await fetch(url, {
        method: formData.id ? "PUT" : "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setIsLoading(false);
        // hideSidebar();
        setTimeout(
          () =>
            navigate(
              formData.id ? "/moje-pozivnice" : "/moje-pozivnice?newInvite",
            ),
          400,
        );
      } else {
        setIsLoading(false);
        handleAlert(
          "Ups, nesto je poslo po krivu. Molimo vas pokusajte kasnije",
          "error",
        );
      }
    } catch (error) {
      setIsLoading(false);
      handleAlert(
        "Ups, nesto je poslo po krivu. Molimo vas pokusajte kasnije",
        "error",
      );
    }
  };

  return (
    <div className="w-full h-full flex items-center justify-center">
      <Stepper
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        onNext={() => setCurrentStep(currentStep + 1)}
        onBack={() => setCurrentStep(currentStep - 1)}
        onFinish={handleSubmit}
        loading={loading}
        buttonRef={buttonRef}
        isDropdownOpen={isDropdownOpen}
        setIsDropdownOpen={setIsDropdownOpen}
        optionsRef={optionsRef}
        formData={formData}
        setFormData={setFormData}
        handleSubmit={handleSubmit}
      >
        <div
          data-hs-stepper-content-item='{"index": 1}'
          style={{ display: currentStep === 1 ? "block" : "none" }}
        >
          <TemplateSection formData={formData} setFormData={setFormData} />
        </div>
        <div
          data-hs-stepper-content-item='{"index": 2}'
          style={{ display: currentStep === 2 ? "block" : "none" }}
        >
          <InvitationPreview
            rsvp={formData}
            isEditable={true}
            onUpdate={setFormData}
          />
        </div>
        <div
          data-hs-stepper-content-item='{
            "isFinal": true
          }'
          style={{ display: currentStep === 3 ? "block" : "none" }}
        >
          <InvitationFinish formData={formData} setFormData={setFormData} />
        </div>
      </Stepper>
    </div>
  );
};

export default CreateInvitationPage;
